<div class="qrscanner">
  <video #video class="qrscanner__video --{{ cameraPosition }}" autoplay></video>
  <canvas #canvas class="qrscanner__canvas"></canvas>
</div>
